import React from 'react'
import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import { t } from 'i18next'
import MiniLoading from 'Components/MiniLoading'
import NoImage from 'Assets/Images/Logos/no-image.png'

function ShowProductsModal({ item, loading, onClose }) {
  const products = item?.ProductList || []

  return (
    <Dialog
      open={!!item}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-testid="modal-quick-list-products">
      <DialogTitle>{item?.Name}</DialogTitle>
      <DialogContent className="quick-list-products-preview">
        <div className="quick-list-products-preview-body">
          {loading ? (
            <MiniLoading />
          ) : products.length === 0 ? (
            <p>{t('QUICK_LIST_SETTINGS.LIST.NO_RESULTS')}</p>
          ) : (
            <table className="quick-list-products-preview-table">
              <thead>
                <tr>
                  <th></th>
                  <th>{t('QUICK_LIST_SETTINGS.LIST.NAME')}</th>
                  <th>{t('QUICK_LIST_SETTINGS.PICKER.SKU')}</th>
                  <th>{t('QUICK_LIST_SETTINGS.FORM.QUANTITY')}</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product, index) => (
                  <tr key={product.ProductId || index}>
                    <td>
                      <img
                        src={product.Images?.[0]?.URL || NoImage}
                        alt={product.ProductName || ''}
                        width={48}
                        height={48}
                        className="quick-list-products-preview-thumb"
                      />
                    </td>
                    <td>{product.ProductName}</td>
                    <td>{product.Sku}</td>
                    <td>{product.Quantity ?? '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ShowProductsModal
